const IS_PROD = process.env.NODE_ENV === 'production';

const PROJECT_NAME = 'SMARTPOLE';
let BACKEND_URL = IS_PROD ? 'https://web.smartpole.com.tr/' : 'http://127.0.0.1:8003/';
let API_BASE_URL = IS_PROD ? 'https://web.smartpole.com.tr/api/' : 'http://127.0.0.1:8003/api/';

const TOKEN_TYPE = 'JWT';

let SOCKET_URL = 'https://socket.smartpole.com.tr';
const CAMERA_URL = '';

export { IS_PROD, TOKEN_TYPE, BACKEND_URL, API_BASE_URL, SOCKET_URL, CAMERA_URL, PROJECT_NAME };
